const Urls = {
  TMS: `${import.meta.env.VITE_TMS_URL}`,
  Utility: `${import.meta.env.VITE_UTILITY_URL}`,
  Resource: `${import.meta.env.VITE_RESOURCE_URL}`,
  Attendance: `${import.meta.env.VITE_ATTENDANCE_URL}`,
  Elastic_Core: `${import.meta.env.VITE_ELASTICCORE_URL}`,
  PID: `${import.meta.env.VITE_PID_URL}`,
  Catalog: `${import.meta.env.VITE_CATALOG_URL}`,
  Widget: `${import.meta.env.VITE_WIDGET_URL}`,
  Progress: `${import.meta.env.VITE_PROGRESS_URL}`,
  Strapi: `${import.meta.env.VITE_PROXY_URL}`,
  Telemetry: `${import.meta.env.VITE_TELEMETRY_URL}`,
  LP_Authoring: `${import.meta.env.VITE_LP_AUTHORING_URL}`,
  Content_Validate: `${import.meta.env.VITE_CONTENT_VALIDATE_URL}`,
  IP_Info: `${import.meta.env.VITE_IPINFO_URL}`,
  Quiz: `${import.meta.env.VITE_QUIZ_URL}`,
  Report: `${import.meta.env.VITE_REPORT_URL}`,
  Course_Controller: `${import.meta.env.VITE_COURSE_CONTROLLER_URL}`,
  Metadata_Generator: `${import.meta.env.VITE_METADATA_GENERATE}`,
  Overall_report: `${import.meta.env.VITE_OVERALL_REPORT}`,
  Learning_Assistance: `${import.meta.env.VITE_LEARNINGASSISTANCE_URL}`,
  Social_Interactions: `${import.meta.env.VITE_SOCIAL_INTERACTIONS_URL}`,
  Cmi5_Authoring: `${import.meta.env.VITE_CMI5_AUTHORING_URL}`,
  Question_Fetch: `${import.meta.env.VITE_QUESTION_URL}`,
  MCQ_Assessment: `${import.meta.env.VITE_MCQASSESSMENT_URL}`,
  Assessment: `${import.meta.env.VITE_ASSESSMENT_URL}`,
  Proctoring_Image: `${import.meta.env.VITE_PROCTORINGIMAGE_URL}`,
  Proctoring: `${import.meta.env.VITE_PROCTORING_URL}`,
  AI_Interview: `${import.meta.env.VITE_INTERVIEW_API_URL}`,
  Discussions: `${import.meta.env.VITE_DISCUSSIONS_URL}`
} as const;

export default Urls;
